export default __webpack_public_path__ + "_/images/matches/man-tablet-939fce5d3a79c4d34e30c3f184c203223bc8ff75e4cb31a157f66023f9982605.png";